// extracted by css-extract-rspack-plugin
export default {"viewInRoomImage":"_585ebe7d"};